module.exports = new __parcel__URL__("success_icon.f11752a4.svg").toString();